import actions from '@/core/store/documentos/anexos/actions'

export default {
	actions,
}
